enum TagType {
	/** 火焰 */
	Hot = 'hot',
	/** 时钟 */
	Clock = 'clock',
	/** 印戳 */
	Stamp = 'stamp',
	/** 标签 */
	Label = 'label',
}

import Tag from './tag.vue';

export {
	Tag,
	TagType,
}